module.exports = __webpack_public_path__ + "r-v3/img/warning_declaration.5980bed5.svg";